import React from 'react';
import { Hero } from "@/components/landing/Hero";
import { FeatureCards } from "@/components/landing/NewFeatures";
import PricingSection from "@/components/landing/Pricing";
import { TrustBuilding } from "@/components/landing/TrustBuilding";
import { BookingForm } from "@/components/landing/BookingForm";
import { Footer } from "@/components/landing/Footer";
import { WhyAcos } from "@/components/landing/WhyAcos";
import CompleteSolution from "@/components/landing/CompleteSolution";
import ROICalculator from "@/components/landing/ROICalculator";
import { RegistrationNotifications } from "@/components/RegistrationNotifications";

const Index = () => {
  return (
    <main className="min-h-screen bg-black text-white overflow-x-hidden">
      <Hero />
      <WhyAcos />
      <FeatureCards />
      <CompleteSolution />
      <ROICalculator />
      <PricingSection />
      <TrustBuilding />
      <BookingForm />
      <Footer />
      <RegistrationNotifications />
    </main>
  );
};

export default Index;